import { useQuery } from "@tanstack/react-query";
import { HospitalAndPcpCountData } from "@app/overviews/network-benchmarking-dashboard/tiles/shared";
import { NetworkComparisonFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/filters/network-comparison-filters/shared/NetworkComparisonFiltersPayload";
import { BenchmarkingServiceType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/utility";

export interface HospitalAndPcpCountDataResult {
  hospitalAndPcpCountData: HospitalAndPcpCountData[];
  hospitalAndPcpCountDataLoading: boolean;
}

export const HOSPITAL_AND_PCP_COUNT_DATA_QUERY_KEY_PREFIX = "benchmarking-hospital-and-pcp-count-data";

export const useHospitalAndPcpCountData = (
  service: BenchmarkingServiceType,
  payload: NetworkComparisonFiltersPayload | null
): HospitalAndPcpCountDataResult => {
  const queryResult = useQuery<HospitalAndPcpCountData[]>({
    enabled: !!payload,
    queryFn: ({ signal }) => service.getHospitalAndPcpCountData(payload, signal),
    queryKey: [HOSPITAL_AND_PCP_COUNT_DATA_QUERY_KEY_PREFIX, service?.lineOfBusiness, JSON.stringify(payload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    hospitalAndPcpCountData: queryResult.data ?? [],
    hospitalAndPcpCountDataLoading: queryResult.isFetching,
  };
}

export default useHospitalAndPcpCountData;
